//@ts-nocheck // Sorry :(((((( Please don't remove
import ClassicEditor from '@ckeditor/ckeditor5-build-classic/build/ckeditor';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { Box, SxProps, Theme } from '@mui/material';

import { taskFormsApi } from '../../axios';

const queryParams = new URLSearchParams(window.location.search);

const customStyles: Record<string, SxProps<Theme>> = {
  editor: {
    '& .ck.ck-editor .ck-editor__top .ck-sticky-panel .ck-toolbar': {
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
      background: '#FAFBFF',
      border: '1px solid #DDE0E5',
      borderBottom: 'none',
    },
    '& .ck.ck-editor__main>.ck-editor__editable:not(.ck-focused)': {
      borderBottomLeftRadius: '8px',
      borderBottomRightRadius: '8px',
      border: '1px solid #DDE0E5',
    },
    '& .ck.ck-dropdown': {
      borderRadius: '4px',
      border: '1px solid #DDE0E5',
      background: '#FFFFFF',
    },
    '& .ck.ck-toolbar>.ck-toolbar__items>:not(.ck-toolbar__line-break), .ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown':
      {
        borderRadius: '4px',
        border: '1px solid #DDE0E5',
        background: '#FFFFFF',
        '&.ck-on': {
          background: '#dedede',
        },
      },
  },
};

interface CkeditorProps {
  value: string;
  onChange: (data: string) => void;
}

class MyUploadAdapter {
  constructor(loader) {
    this.loader = loader;
  }

  upload() {
    return this.loader.file.then(
      (file) =>
        new Promise((resolve, reject) => {
          return taskFormsApi.uploadImage(file, undefined).then((response) => {
            if (response.url) {
              this.loader.uploaded = true;
              resolve({
                default: response.url,
              });
            } else {
              reject(`Couldn't upload file: ${file.name}.`);
            }
          });
        }),
    );
  }
}

const Ckeditor = (props: CkeditorProps) => {
  const { value, onChange } = props;

  function customUploadAdapterPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
      return new MyUploadAdapter(loader);
    };
  }

  const config = {
    extraPlugins: [customUploadAdapterPlugin],
    toolbar: {
      items: [
        'heading',
        '|',
        'bold',
        'italic',
        '|',
        'bulletedList',
        'numberedList',
        '|',
        'insertTable',
        '|',
        'link',
        'imageUpload',
        'mediaEmbed',
        '|',
        'undo',
        'redo',
      ],
    },
    link: {
      addTargetToExternalLinks: true,
    },
    mediaEmbed: {
      previewsInData: true,
    },
    language: queryParams.get('lang') || 'en',
    image: {
      toolbar: ['imageTextAlternative', 'imageStyle:inline', 'imageStyle:block', 'imageStyle:side'],
      insert: {
        integrations: ['upload'],
      },
    },
    table: {
      contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
    },
    licenseKey: '',
  };

  return (
    <Box sx={customStyles.editor}>
      <CKEditor
        id={'ckeditor'}
        editor={ClassicEditor}
        config={config}
        data={value}
        onChange={(_, editor) => {
          const data = editor?.getData();
          if (data) onChange(data);
        }}
        onReady={(editor) => {
          if (editor) {
            editor.editing.view.change((writer) => {
              writer.setStyle('height', '300px', editor.editing.view.document.getRoot());
            });
          }
          onChange(value || '');
        }}
      />
    </Box>
  );
};

export { Ckeditor };
